import { searchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import Search from "@insite/mobius/Icons/Search";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

searchInputStyles.input = {
    iconProps: { src: Search },
    cssOverrides: {
        formField: css`
            width: 302px;
            input {
                border-width: 2px !important;
                background-color: #f3f1f1 !important;
                font-size: 12px !important;
                text-transform: uppercase;
            }
        `,
    },
};
